import React from 'react';

import { flagStyles } from '../settings';

const SvgGG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1896px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGG;
